export const CANCELLATION_MESSAGE = [
  {value: "bulk-cancel-preorder-postponed", label: "Preorder Postponed"},
  {value: "bulk-cancel-preorder-dropped", label: "Preorder Dropped"},
  // { value: "cancelled-by-api", label: "Cancelled by API" }, // Remove option as it is not used by SQX.
];

export const DEFAULT_MESSAGE = "bulk-cancel-preorder-dropped";
